import { render, staticRenderFns } from "./addPostcard.vue?vue&type=template&id=34895432&scoped=true"
import script from "./addPostcard.vue?vue&type=script&lang=js"
export * from "./addPostcard.vue?vue&type=script&lang=js"
import style0 from "./addPostcard.vue?vue&type=style&index=0&id=34895432&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34895432",
  null
  
)

export default component.exports